@if (dataReady) {
  <div class="grid-container">
    <div class="grid-x">
      <div class="small-12 medium-12 large-12 bold">
        Casing Strings
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <ag-grid-angular class="data-grid " [rowData]="well?.casingTubing" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" aria-label="Well Detail Casing Strings"></ag-grid-angular>
      </div>
    </div>
  </div>
  <edit-casing-tubing-record [casingTypes]="filteredCasings" [tools]="tools" (recordEdited)="recordEdited($event)"></edit-casing-tubing-record>
}
